"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvCharging = void 0;
const react_1 = __importDefault(require("react"));
const EVChargingSection_1 = require("@geome/react-components-next/lib/components/EVChargingSection");
const ev_1 = require("./icons/ev");
const mobile_payment_svg_1 = __importDefault(require("../images/mobile-payment.svg"));
const contactless_svg_1 = __importDefault(require("../images/contactless.svg"));
const shell_locator_icons_1 = __importDefault(require("@geome/shell-locator-icons"));
const react_next_1 = require("@geome/react-next");
const sectionWithTitle_1 = require("@geome/react-components-next/lib/components/sectionWithTitle");
const PAYMENT_ICONS = {
    new_motion_app: mobile_payment_svg_1.default,
    rfid_token: contactless_svg_1.default,
};
const EvCharging = ({ data }) => {
    const { translate } = (0, react_next_1.useI18n)();
    if (!data)
        return (react_1.default.createElement(sectionWithTitle_1.SectionWithTitle, { sectionTokenPath: "station_page.sections.ev_charging", id: "ev_charging", renderIcon: () => react_1.default.createElement(ev_1.EVIcon, null) }, translate("station_page.sections.ev_charging.unavailable")));
    return react_1.default.createElement(EvChargingInner, { data: data });
};
exports.EvCharging = EvCharging;
const EvChargingInner = ({ data }) => {
    const { translate } = (0, react_next_1.useI18n)();
    const { auth_methods: authMethods, charging_points: chargingPoints, available_charging_points: availableChargingPoints, connector_data: connectorData, } = data;
    return (react_1.default.createElement(react_next_1.CSSCustomPropertyContextProvider, { properties: {
            "--primary-colour": "#66c5d2",
        } },
        react_1.default.createElement(EVChargingSection_1.EVChargingSection, { authMethods: authMethods, chargingPoints: chargingPoints, connectorData: connectorData, availableChargingPoints: availableChargingPoints, icons: shell_locator_icons_1.default, paymentIcons: PAYMENT_ICONS, sectionName: "ev_charging", configPath: "station_page.", sectionProps: { renderIcon: () => react_1.default.createElement(ev_1.EVIcon, null) } })));
};
